import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IAppointmentsTabsConfiguration } from '../servants/appointments_tabs_configuration';
import { IAvailableTime } from '../types/appointment_interfaces';
import { ILocation, ILocationCourses, IOrganizer } from '../types/appt_interfaces';
import { TAppointmentAvailableTimesUsersource } from '../usersources/appointment_available_times_usersource';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';

angular
  .module('capability-ng-appointments')
  .factory(
    'loadAppointmentsStaffCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
      ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
      ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
      log: any
    ): ICommand => {
      return defineCommand(
        'loadAppointmentsStaffCommand',
        (deferred: ng.IDeferred<IQuery[]>, location: ILocation): void => {
          if (ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id !== location.id) {
            ngAppointmentsTabsConfiguration.resetNextSteps('1');
            ngAppointmentLocationsOrganizersUsersource.set('selectedLocation', location);
            ngAppointmentLocationsOrganizersUsersource.set('selectedCourse', {} as ILocationCourses);
            ngAppointmentLocationsOrganizersUsersource.set('selectedOrganizers', [] as IOrganizer[]);
            ngAppointmentAvailableTimesUsersource.set('selectedTime', {} as IAvailableTime);
            ngAppointmentAvailableTimesUsersource.set('selectedTimeDetails', {} as IAvailableTime);
          }
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/appointments_location_selected_command.ts